import classNames from 'classnames';
import type { JSX, ReactNode } from 'react';
import React from 'react';

import * as styles from './MascotAssistant.css';

import defaultMascotImage from '@feathr/extender/images/super_pixel_mascot.png';

interface IMascotAssistantProps {
  text: ReactNode;
  mascotImage?: string;
  layout?: 'vertical' | 'horizontal';
}

function MascotAssistant({
  text,
  mascotImage = defaultMascotImage,
  layout = 'vertical',
}: Readonly<IMascotAssistantProps>): JSX.Element {
  return (
    <div className={classNames(styles.root, styles[layout])}>
      <div className={styles.speechBubble}>{text}</div>
      <img alt={'Mascot'} className={styles.mascotImage} src={mascotImage} />
    </div>
  );
}

export default MascotAssistant;
